export default __webpack_public_path__ + "fonts/a0b8a4ffdb65d042f1d12b7a710a35ec.svg";